import { FunctionComponent } from 'react';

import classes from './pure-static-content.module.css';

const PureStaticContent: FunctionComponent<{ html: string }> = ({ html }) => (
  <div
    className={classes.markdown}
    dangerouslySetInnerHTML={{ __html: html }}
  />
);

export default PureStaticContent;
